import * as signalR from "@microsoft/signalr";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/hubs/notification";

class SignalRService {
  private hubConnection: signalR.HubConnection;

  constructor() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${api_base_url}`)
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.startConnection();
    this.addGlobalSilentHandler();
  }

  private startConnection = async () => {
    try {
      await this.hubConnection.start();
      //console.log("SignalR Connected.");
    } catch (err) {
      //console.error("SignalR Connection Error: ", err);
      setTimeout(this.startConnection, 5000); // Retry after 5 seconds
    }
  };

  // Global handler to ignore unregistered methods silently
  private addGlobalSilentHandler = () => {
    this.hubConnection.on("ReceiveJobStatus", () => {
      // No-op, just ignore if there's no registered callback
    });
  };

  public onJobStatusUpdate = (
    callback: (jobId: string, isRunning: boolean) => void
  ) => {
    this.hubConnection.on(
      "ReceiveJobStatus",
      (jobId: string, isRunning: boolean) => {
        callback(jobId, isRunning);
      }
    );
  };

  public offJobStatusUpdate = (
    callback: (jobId: string, isRunning: boolean) => void
  ) => {
    this.hubConnection.off("ReceiveJobStatus", callback);
  };
}

export default new SignalRService();
